if (!customElements.get('watches-duo')) {
  customElements.define('watches-duo', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.motion = matchMedia('(prefers-reduced-motion:reduce)');
      const clamp = value => Math.min(1, Math.max(0, value));
      this.update = () => {
        this.frame = null;
        const rect = this.getBoundingClientRect();
        const viewport = window.innerHeight;
        const staticMode = this.dataset.animation !== 'true' || this.motion.matches || viewport < 700;
        const reveal = staticMode ? 1 : clamp((viewport - rect.top) / (viewport * .62));
        const travel = staticMode ? 1 : clamp((viewport - rect.top) / Math.max(1, rect.height));
        this.style.setProperty('--wd-mask', `${(1 - reveal) * 100}%`);
        this.style.setProperty('--wd-copy-y', `${(1 - travel) * viewport * .3}px`);
      };
      this.schedule = () => { if (this.frame == null) this.frame = requestAnimationFrame(this.update); };
      window.addEventListener('scroll', this.schedule, {passive:true, signal});
      window.addEventListener('resize', this.schedule, {signal});
      this.motion.addEventListener('change', this.schedule, {signal});
      this.update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      cancelAnimationFrame(this.frame);
      this.frame = null;
    }
  });
}
